module.exports = __webpack_public_path__ + "static/img/112.7eef27e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/112.png
// module id = haXM
// module chunks = 0